var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-loader-container"},[_c('div',{staticClass:"inline-loader"},[_c('div',{staticClass:"cmg-inner-div",class:_vm.spinningCircleClass})])])
}
var staticRenderFns = []

export { render, staticRenderFns }